import { createTheme, ThemeOptions } from "@mui/material/styles";
import { CSSProperties } from "react";

declare module "@mui/material/styles" {
  interface Theme {
    custom: {
      pageTitle: CSSProperties;
    };
  }
  interface ThemeOptions {
    custom?: {
      pageTitle?: CSSProperties;
    };
  }
}

const themeOptions: ThemeOptions = {
  typography: {
    fontFamily: "'Open Sans', sans-serif;",
    fontSize: 18,
    fontWeightRegular: 300,
  },
  palette: {
    primary: {
      // main: "#1a237e", // Dark blue
      main: "#003087", // Amtrak's primary blue
      light: "#004fb6", // Lighter variant for hover states
      dark: "#002266", // Darker variant for active states
      contrastText: "#fff", // Text color for primary buttons
    },
    secondary: {
      main: "#b71c1c", // Dark red
    },
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          // You can add global styles for icons here
          // For example:
          // fontSize: '1.5rem',
        },
      },
    },
    // Add other component overrides as needed
    MuiButton: {
      styleOverrides: {
        root: {
          // textTransform: "none", // Prevents all-caps button text
        },
        contained: {
          boxShadow: "none", // Removes default Material UI shadow
          "&:hover": {
            boxShadow: "none", // Removes shadow on hover
          },
        },
      },
    },
  },
  custom: {
    pageTitle: {
      marginTop: -0.8,
    },
  },
  // Add more custom theme options here
};

export const theme = createTheme(
  themeOptions as ThemeOptions & {
    custom: {
      pageTitle: CSSProperties;
    };
  }
);

export default theme;
